<template>
  <component
    :is="href ? 'a' : 'span'"
    :href="href"
    class="def-link"
    :class="{ 'def-link_disabled': disabled }"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'DefLink',
  props: {
    href: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.def-link {
  text-decoration-line: underline;
  text-underline-position: under;
  transition: 0.2s linear color;
  cursor: pointer;
  text-underline-color: currentColor;
  color: var(--color-main);
  &:hover {
    color: var(--color-dark-grey);
  }
  &_disabled {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed;
  }
}
</style>
